import { render, staticRenderFns } from "./logistic.vue?vue&type=template&id=2d1b3aa6&scoped=true"
import script from "./logistic.vue?vue&type=script&lang=js"
export * from "./logistic.vue?vue&type=script&lang=js"
import style0 from "./logistic.vue?vue&type=style&index=0&id=2d1b3aa6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1b3aa6",
  null
  
)

export default component.exports